import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const steps = [{
  name: 'Source',
  detail: 'Portals, email ingestion, Raiseboards'
}, {
  name: 'Ingest',
  detail: 'Decks, data rooms, documents'
}, {
  name: 'Research',
  detail: 'Market, competition, comparables'
}, {
  name: 'Diligence',
  detail: 'Gap analysis, business risk'
}, {
  name: 'Score',
  detail: 'Thesis fit, data sufficiency'
}, {
  name: 'Memo',
  detail: 'Tear sheets, investment memos'
}, {
  name: 'Decision',
  detail: 'Team review and voting'
}, {
  name: 'Monitor',
  detail: 'Portfolio companies'
}, {
  name: 'Report',
  detail: 'Portfolio and LP reporting'
}];
export function WorkflowSlide() {
  return <Slide data-id="element-473" data-mp="srbkzi7nxw4s">
      <Eyebrow data-id="element-474" data-mp="srtpf24hbgns">How a firm uses DiligenceGPT™</Eyebrow>
      <Title className="mt-[2.2cqh]" data-id="element-475" data-mp="ntjw6x2beq4t">One intelligence layer across the investment workflow.</Title>

      <div className="mt-auto" data-id="element-476" data-mp="1emmaudzfeygu">
        <div className="relative grid grid-cols-9" data-id="element-477" data-mp="1elknba184ji8">
          <div className="absolute left-[5.5%] right-[5.5%] top-[1.6cqw] h-px bg-white/15" aria-hidden data-id="element-478" data-mp="1jd2q83mt4u5u" />
          {steps.map((s, i) => <Reveal key={s.name} delay={0.04 * i} className="relative flex flex-col items-center px-[0.4cqw] text-center" data-id="element-479" data-mp="15mqulur0kd9y" data-mpi={i}>
              <span className="relative flex h-[3.2cqw] w-[3.2cqw] items-center justify-center rounded-full border bg-[#070B14] text-[0.86cqw] tracking-[0.1em]" style={{
            borderColor: i === 4 ? INK.blue : 'rgba(255,255,255,0.25)',
            color: i === 4 ? INK.blue : '#AEB7C7'
          }} data-id="element-480" data-mp="1al0rqawatny7">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="mt-[2.4cqh] text-[1.45cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-481" data-mp="cxa4x4us3ahf">
                {s.name}
              </p>
              <p className="mt-[1.4cqh] text-[0.9cqw] leading-snug text-[#8B95A8]" data-id="element-482" data-mp="hwwjbhmcewrt">{s.detail}</p>
            </Reveal>)}
        </div>

        <Reveal delay={0.42} className="mt-[5cqh] flex items-center justify-between border border-[#2FBE8F]/40 bg-[#2FBE8F]/[0.06] px-[2cqw] py-[2.6cqh]" data-id="element-483" data-mp="3pxrs2jpgjv8l">
          <div className="flex items-center gap-[1.2cqw]" data-id="element-484" data-mp="3l4ylrrecceue">
            <span className="text-[1.4cqw] text-[#2FBE8F]" aria-hidden data-id="element-485" data-mp="3g6x1j356i9hc">
              ↺
            </span>
            <p className="text-[1.5cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-486" data-mp="3b9ojr3ny07gm">
              Institutional memory
            </p>
          </div>
          <Label tone={INK.emerald} data-id="element-487" data-mp="32879i1x7uzzu">Every step writes back: decisions, scores, feedback, outcomes</Label>
        </Reveal>
      </div>
    </Slide>;
}